import React, { Component } from 'react';
export class IframeInBoundListener extends Component {
  constructor(props) {
    super(props);
    this.iframeRef = null;
    this.style = this.getStyle();
  }

  componentDidMount() {
    const iframe = document.getElementById('inbound');
    iframe.onload = () => {
      this.sendInputDataToIframe(this.props.inputData);
    };
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    const iframe = document.getElementById('inbound');
    if (iframe) {
      const doc = iframe.contentDocument;
      if (doc) {
        doc.removeEventListener('click', this.handleIframeClick);
        doc.removeEventListener('keydown', this.handleIframeKeyDown);
      }
    }
  }

  sendInputDataToIframe = (inputData) => {
    if (inputData) {
      this.iframeRef.contentWindow.postMessage(inputData, '*');
    }
  };

  handleMessage = (event) => {
    if (event.data?.origin == 'IPA') return this.props.onDataReceived(event.data);
  };

  getStyle = () => {
    const windowWidth = window.innerWidth;
    const iframeWidth = windowWidth - 200;
    const leftPosition = (windowWidth - iframeWidth) / 2;

    const style = {
      left: `${leftPosition}px`,
      width: `${iframeWidth}px`,
      height: '100%',
      minHeight: '1942px',
      position: 'absolute',
      border: 'none',
      maxWidth: `${iframeWidth}px`,
      backgroundColor: 'white'
    };

    return style;
  }

  scrollToIframe = () => {
    const iframe = document.getElementById('inbound');
    if (iframe) {
      iframe.scrollIntoView();
    }
  };

  render() {
    return (
      <div style={{ height: "1442px" }}>
        <iframe
          id="inbound"
          ref={(element) => (this.iframeRef = element)}
          src={this.props.IPAenvironmentURL}
          style={this.style}
          title="Iframe Content"
          onLoad={() => this.scrollToIframe()}
          onError={(err) => console.log('Iframe failed to load.', err)}
          allow="cross-origin-isolated"
          data-dd-iframe
        />
      </div>
    );
  }
}
